const AuthLayout = ({ component }: { component: any }) => (
    <div className="aut-bg-img">
        <div className="auth-content" style={{}}>
            {component}
        </div>
    </div>
);

export default AuthLayout;  